document.addEventListener('DOMContentLoaded', () => {
  const PREORDER_PROPERTY = '_is_preorder';

  async function getCart() {
    const res = await fetch('/cart.js');
    return await res.json();
  }

  function cartHasPreorder(cart) {
    return cart.items.some(item => {
      return item.properties && item.properties[PREORDER_PROPERTY] === 'true';
    });
  }

  function currentFormIsPreorder(form) {
    return form.querySelector(`[name="properties[${PREORDER_PROPERTY}]"][value="true"]`) !== null;
  }

  async function handleAddToCartSubmit(e) {
    const form = e.target;
    if (!form.matches('form[action*="/cart/add"]')) return;

    try {
      const cart = await getCart();
      const hasPreorderInCart = cartHasPreorder(cart);
      const addingPreorder = currentFormIsPreorder(form);
      const cartHasOtherItems = cart.items.length > 0 && !hasPreorderInCart;

      // Cas 1 : panier a une précommande, on bloque tout autre ajout
      if (hasPreorderInCart && !addingPreorder) {
        e.preventDefault();
        e.stopImmediatePropagation();
        alert("Cette précommande doit être achetée seule.");
        return;
      }

      // Cas 2 : panier a des produits normaux, on bloque l’ajout d’une précommande
      if (addingPreorder && cartHasOtherItems) {
        e.preventDefault();
        e.stopImmediatePropagation();
        alert("La précommande doit être achetée séparément des autres articles.");
        return;
      }
    } catch (err) {
      console.error('Cart guard error:', err);
    }
  }

  document.addEventListener('submit', handleAddToCartSubmit, true);
});